import { Hyperlink } from "@ebsco-ui/ebsco-ui";
import React, { useState } from "react";
import { useField } from "react-final-form";
import { FormattedMessage } from "react-intl";
import { bool as yupBool } from "yup";
import { EBSCO_URLS } from "../../../../constants";
import CheckboxField from "../../checkbox-field";
import {
  CreatePasswordField,
  EmailField,
  FamilyNameField,
  GivenNameField
} from "../../shared/fields";
import createUserFormMessages from "../create-user-form/create-user-form-messages";
import DataRetentionModal from "../data-retention-modal";

const NonCoppaUpdateUserFormFields = () => {
  useField("isCoppa", {
    defaultValue: false
  });

  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleModalClose = () => setIsModalOpen(false);

  const grantConsentValidationSchema = yupBool()
    .required()
    .oneOf([true]);

  return (
    <>
      <GivenNameField />
      <FamilyNameField />
      <EmailField />
      <CreatePasswordField />
      <CheckboxField
        name="grantConsent"
        className="grant-consent-message"
        label={
          <FormattedMessage
            {...createUserFormMessages.acceptConsent}
            values={{
              a: displayLink()
            }}
          />
        }
        id="grant-consent"
        validationSchema={grantConsentValidationSchema}
        aria-required="true"
      />
      <DataRetentionModal isOpen={isModalOpen} onClose={handleModalClose} />
    </>
  );
};

const displayLink = () => msg => (
  <Hyperlink href={EBSCO_URLS.PRIVACY_POLICY} target="_blank">
    {msg}
  </Hyperlink>
);

export default NonCoppaUpdateUserFormFields;
